import { render, staticRenderFns } from "./RemoveThemeModal.vue?vue&type=template&id=1a895b5b&lang=pug"
import script from "./RemoveThemeModal.vue?vue&type=script&lang=js"
export * from "./RemoveThemeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports